/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconWashDryclean = createReactComponent("outline", "wash-dryclean", "IconWashDryclean", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }]]);

export { IconWashDryclean as default };
//# sourceMappingURL=IconWashDryclean.mjs.map
